import { RootState } from '../types'
import { connect } from 'react-redux'
import BondDetailDialog from '../components/BondDetailDialog'
import { BondActions, buyBondAction, hideBondDetailDialog } from '../actions/bondActions'
import { Action, Dispatch } from 'redux'
import { MT4Connector } from '@bdswiss/mt4-connector'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  return {
    bondsTradingPane: rootState.bondsTradingPane,
    selectedBond: rootState.bondListState.selectedBond,
    account: mt4.account, // rootState.tradingAccount,
    demo: rootState.appConfig.demo,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<BondActions | Action>) {
  return {
    onCloseDialog: () => {
      dispatch(hideBondDetailDialog())
    },
    buyBond: (mt4Symbol: string, volume: number) => {
      dispatch(buyBondAction(mt4Symbol, volume))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondDetailDialog)
